<mat-icon [popover]="popTemplate" popoverTitle="Missed GAPI data Statistic" [outsideClick]="true"
    containerClass="process-stat-popover-container" [placement]="'left'" [ngClass]="getStatusClass()"
    [title]="getHint()" style="cursor: pointer;">fiber_manual_record</mat-icon>
<ng-template #popTemplate>
    <div style="position: unset;">
        <div [innerHtml]="getTooltipValue()"></div>
    </div>
</ng-template>